// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- HS Code
import { Constants } from '../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class CookiePolicyService {

  private _accepted$: BehaviorSubject<boolean>;
  get accepted$(): Observable<boolean> {
    return this._accepted$;
  }
  private _initialized$: BehaviorSubject<boolean>;
  get initialized$(): Observable<boolean> {
    return this._initialized$;
  }

  constructor() {
    this._accepted$ = new BehaviorSubject<boolean>(false);
    this._initialized$ = new BehaviorSubject<boolean>(false);
  }

  init() {
    const cookieExists = this.checkCookie(Constants.COOKIE_POLICY_KEY) ? true : false;
    this._accepted$.next(cookieExists);
    this._initialized$.next(true);
  }

  accept() {
    this.setCookie(Constants.COOKIE_POLICY_KEY, 'accepted', Constants.COOKIE_POLICY_EXPIRY);
    this._accepted$.next(true);
  }

  private checkCookie(name: string) {
    return this.getCookie(name);
  }

  private setCookie(name: string, value: string, expiryInDays: number) {
    const d = new Date();
    d.setTime(d.getTime() + (expiryInDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  private getCookie(name: string) {
    const allCookies = decodeURIComponent(document.cookie).split('; ');
    for (const cookie of allCookies) {
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  }
}
